
import { isElement } from 'lodash';
import { isElementOfType } from 'react-dom/test-utils';
import {IElement, ITextAttributes, IImageAttributes, IShapeCustomAttributes, IShapeKnot, IShapeCommonAttributes} from 'routes/private/Editor/types';
import {IResizeValues} from './types'
import { updateRenderingTextSegments } from 'utils/textMultiStyling'

export const resizeResolver = ( element: IElement, value: IResizeValues ) => {
    if (value===undefined) return element;

    //new TextResize
    if (element.type == "Text"){
        if (value.factor)
        {
            (element.attributes as ITextAttributes).parts.map((part,index)=>{
                if (part.style.fontSize !== undefined) {
                    part.style.fontSize = (part.style.fontSize) * (value.factor??1)
                }
            });
            if ((element.attributes as ITextAttributes).style.fontSize !== undefined) {
                (element.attributes as ITextAttributes).style.fontSize = (element.attributes as ITextAttributes).style.fontSize! * (value.factor??1);
            }
        }
    }
    
    if (value.rotation!==undefined) {
        element.attributes.rotation = value.rotation;
    }
    else {
        element.attributes.rotation = 0;
    }
    const leftMove = value.x - element.attributes.x;            
    const topMove = value.y - element.attributes.y;            
    const widthChange = value.width - element.attributes.width;            
    const heightChange = value.height - element.attributes.height;      
    element.attributes.x = value.x;
    element.attributes.y = value.y;
    element.attributes.width = value.width;
    element.attributes.height = value.height;       
    if (element.attributes.rawProps?.length && element.attributes.rawProps[0]?.mask) {
        if (element.attributes.rawProps[0]?.mask.left) element.attributes.rawProps[0].mask.left = element.attributes.rawProps[0]?.mask.left+leftMove;       
        if (element.attributes.rawProps[0]?.mask.top) element.attributes.rawProps[0].mask.top = element.attributes.rawProps[0]?.mask.top+topMove;       
        if (element.attributes.rawProps[0]?.mask.right) element.attributes.rawProps[0].mask.right = element.attributes.rawProps[0]?.mask.right+widthChange;       
        if (element.attributes.rawProps[0]?.mask.bottom) element.attributes.rawProps[0].mask.bottom = element.attributes.rawProps[0]?.mask.bottom+heightChange;       
    }
    if (element.type == "Image" && value.image)(element.attributes as IImageAttributes).image = value.image;
    if (element.type == "Shape")
    {
        if ((element.attributes as IShapeCommonAttributes).shapeType == "Custom")
        {
         (element.attributes as IShapeCustomAttributes).knots.map((knot:IShapeKnot)=>{
             if (knot.points)
             {
                 knot.points[0]= knot.points[0] + leftMove
                 knot.points[1] = knot.points[1] + topMove;
             }
         })
        }
    }

    if (element.type == "Text"){
        element.attributes = updateRenderingTextSegments(element.attributes as ITextAttributes);
    }
   return element;
}